<div class="icon-wrap"
     *ngIf="!isImportSection"
     [ngClass]="{'pointer': activeConnectionsAmount}">
    <mat-icon *ngIf="!hasMultipleConnections" [matBadgeHidden]="!activeConnectionsAmount" matBadge="{{activeConnectionsAmount}}" matBadgeColor="primary">person</mat-icon>
    <mat-icon *ngIf="hasMultipleConnections" matBadge="{{activeConnectionsAmount}}" matBadgeColor="primary">people</mat-icon>
</div>
<app-active-connected-users-popup class="connections-popup" [connectedClients]="activeConnection"></app-active-connected-users-popup>
